var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Icons;
(function (Icons) {
    Icons["eye"] = "/identity/assets/images/sprite.svg#eye";
    Icons["eyeClosed"] = "/identity/assets/images/sprite.svg#eye-closed";
    Icons["checked"] = "/identity/assets/images/sprite.svg#checked";
})(Icons || (Icons = {}));
(function () {
    'use strict';
    document.documentElement.classList.add('js-enabled');
    var PASSWORD_REGEX = new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()"№;:?_+])(?!.*[а-яА-Я ]).{8,30}$/);
    var EMAIL_REGEX = new RegExp('^[\\w]+([\\._-][\\w]+)*@[a-zа-я0-9]+([\\.-][a-zа-я0-9]+)*(\\.[a-zа-я0-9]{2,})$');
    var USERNAME_REGEX = new RegExp('^[a-zA-Z0-9]{4,30}$');
    var $login = document.getElementById('login');
    var $username = document.getElementById('username');
    var $password = document.getElementById('password');
    var $newPassword = document.getElementById('newPassword');
    var $confirmedNewPassword = document.getElementById('confirmedNewPassword');
    var $passwordVisibilityButton = document.querySelectorAll('.password-visibility');
    var $email = document.getElementById('email');
    var $userAgreementCheckbox = document.getElementById('userAgreement');
    var $languageSelector = document.getElementById('language');
    var $submitButton = document.getElementById('submitButton');
    var $formElement = document.getElementById('form');
    var $serverFeedbacks = document.querySelectorAll('.server-feedback');
    var $serverErrorFields = document.querySelectorAll('.invalid');
    var $digitCodeInput = document.querySelector('#digit-code-input');
    var $digitCodeButton = document.querySelector('#digit-code-button');
    var $forgotPasswordTabs = document.querySelector('#forgot-password-tabs');
    var $countrySelect = document.querySelector('#countryId');
    var $countrySearch = document.querySelector('#countrySearch');
    var $countrySearchList = document.querySelector('#countrySearchList');
    var $countrySearchToggle = document.querySelector('#countrySearchToggle');
    if ($languageSelector !== null) {
        $languageSelector.addEventListener('change', onLanguageChanged);
    }
    if ($userAgreementCheckbox !== null) {
        $userAgreementCheckbox.addEventListener('input', onUserAgreementInput);
    }
    if ($email !== null) {
        $email.addEventListener('input', onEmailInput);
        $email.addEventListener('blur', onInputBlur);
    }
    if ($username !== null) {
        $username.addEventListener('input', onUsernameInput);
        $username.addEventListener('blur', onInputBlur);
    }
    if ($login !== null) {
        $login.addEventListener('input', checkLogin);
    }
    if ($password !== null) {
        $password.addEventListener('input', checkPasswordValidation);
    }
    if ($newPassword !== null) {
        $newPassword.addEventListener('input', onPasswordNewPasswordInput);
        $newPassword.addEventListener('blur', onInputBlur);
    }
    if ($confirmedNewPassword !== null) {
        $confirmedNewPassword.addEventListener('input', onPasswordConfirmPasswordInput);
        $confirmedNewPassword.addEventListener('blur', onInputBlur);
    }
    if ($passwordVisibilityButton !== null) {
        $passwordVisibilityButton
            .forEach(function (visibilityButton) { return visibilityButton.addEventListener('click', togglePasswordVisibility); });
    }
    if ($digitCodeInput !== null && $digitCodeButton !== null) {
        createDigitCodeInput();
    }
    if ($forgotPasswordTabs !== null) {
        checkForgotPasswordValidation();
    }
    if ($countrySelect !== null && $countrySearch !== null) {
        initCountrySelectFilter();
    }
    function onLanguageChanged() {
        if ($languageSelector) {
            setCookie('.AspNetCore.Culture', "c=".concat($languageSelector.value, "|uic=").concat($languageSelector.value));
            window.location.href = window.location.href;
        }
    }
    function onUserAgreementInput() {
        if ($userAgreementCheckbox) {
            $userAgreementCheckbox.value = $userAgreementCheckbox.checked.toString();
        }
        checkFormValidity();
    }
    function checkLogin() {
        checkInputEmpty($login);
        checkFormValidity();
        resetServerValidation();
    }
    function checkPasswordValidation() {
        checkInputEmpty($password);
        checkFormValidity();
        resetServerValidation();
    }
    function onInputBlur(event) {
        var $inputElement = this;
        setTouched($inputElement);
    }
    function onUsernameInput(event) {
        var $inputElement = this;
        setTouched($inputElement);
        checkLoginValidation();
        checkInputEmpty($inputElement);
        checkFormValidity();
        resetServerValidation();
    }
    function onEmailInput(event) {
        var $inputElement = this;
        setTouched($inputElement);
        checkEmailValidation();
        checkInputEmpty($inputElement);
        checkFormValidity();
        resetServerValidation();
    }
    function onPasswordNewPasswordInput(event) {
        var $inputElement = this;
        setTouched($inputElement);
        checkNewPasswordValidation();
        checkInputEmpty($inputElement);
        checkFormValidity();
        resetServerValidation();
    }
    function onPasswordConfirmPasswordInput(event) {
        var $inputElement = this;
        setTouched($inputElement);
        checkConfirmPasswordValidation();
        checkInputEmpty($inputElement);
        checkFormValidity();
        resetServerValidation();
    }
    function setTouched($inputElement) {
        $inputElement.classList.add('touched');
    }
    function checkLoginValidation() {
        var $usernameMsgElement = $username.parentElement.querySelector('.validation-error-message');
        var isUsernameMatched = isUsernameMatchPattern($username.value);
        if (isUsernameMatched) {
            $username.classList.remove('invalid');
            $usernameMsgElement.classList.remove('active');
        }
        else {
            $username.classList.add('invalid');
            $usernameMsgElement.classList.add('active');
        }
    }
    function checkEmailValidation() {
        var $emailMsgElement = $email.parentElement.querySelector('.validation-error-message');
        var isEmailMatched = isEmailMatchPattern($email.value);
        if (isEmailMatched) {
            $email.classList.remove('invalid');
            $emailMsgElement.classList.remove('active');
        }
        else {
            $email.classList.add('invalid');
            $emailMsgElement.classList.add('active');
        }
    }
    function checkNewPasswordValidation() {
        var $newPassMsgElement = $newPassword.parentElement.querySelector('.validation-error-message');
        var isPasswordMatched = isPasswordMatchPattern($newPassword.value);
        if (isPasswordMatched) {
            $newPassword.classList.remove('invalid');
            $newPassMsgElement.classList.remove('active');
        }
        else {
            $newPassword.classList.add('invalid');
            $newPassMsgElement.classList.add('active');
        }
    }
    function checkConfirmPasswordValidation() {
        var $confirmPassMsgElement = $confirmedNewPassword.parentElement.querySelector('.validation-error-message');
        var isTheSamePassword = comparePasswords();
        if (isTheSamePassword) {
            $confirmedNewPassword.classList.remove('invalid');
            $confirmPassMsgElement.classList.remove('active');
        }
        else {
            $confirmedNewPassword.classList.add('invalid');
            $confirmPassMsgElement.classList.add('active');
        }
    }
    function togglePasswordVisibility(event) {
        var icon = this.querySelector('svg use');
        var passElement = document.getElementById(this.dataset.field);
        if (passElement.getAttribute('type') === 'password') {
            passElement.setAttribute('type', 'text');
            icon.setAttribute('href', Icons.eye);
        }
        else {
            passElement.setAttribute('type', 'password');
            icon.setAttribute('href', Icons.eyeClosed);
        }
    }
    function checkFormValidity() {
        if ($submitButton && $formElement) {
            $submitButton.disabled = !$formElement.checkValidity() || ($userAgreementCheckbox && !$userAgreementCheckbox.checked);
        }
    }
    function checkInputEmpty(input) {
        if (input.value == null || input.value === '') {
            input.classList.add('empty');
        }
        else {
            input.classList.remove('empty');
        }
    }
    function resetServerValidation() {
        if ($serverFeedbacks) {
            $serverFeedbacks.forEach(function (feedback) { return feedback.classList.add('d-none'); });
        }
        if ($serverErrorFields) {
            $serverErrorFields.forEach(function (field) { return field.classList.remove('invalid'); });
        }
    }
    function isUsernameMatchPattern(password) {
        return USERNAME_REGEX.test(password);
    }
    function isPasswordMatchPattern(password) {
        return PASSWORD_REGEX.test(password);
    }
    function isEmailMatchPattern(email) {
        return EMAIL_REGEX.test(email);
    }
    function isPhoneMatchPattern(phone) {
        // TODO: update phone validator
        return phone.length >= 10;
    }
    function comparePasswords() {
        return $newPassword.value === $confirmedNewPassword.value;
    }
    function checkForgotPasswordValidation() {
        var $contentEmail = document.querySelector('#forgot-password-content-email');
        var $inputEmail = $contentEmail.querySelector('input');
        var $errorEmailMessage = document.querySelector('#forgot-password-email-error-message');
        var $submitButton = document.querySelector('#submitButton');
        if ($inputEmail === null ||
            $errorEmailMessage === null ||
            $submitButton === null) {
            console.error('Not found required element in forgot password tabs');
            return;
        }
        $inputEmail.addEventListener('input', function () {
            checkForgotPasswordEmailValidation();
        });
        checkForgotPasswordEmailValidation();
        function checkForgotPasswordEmailValidation() {
            $submitButton.disabled = true;
            var isEmailMatched = isEmailMatchPattern($inputEmail.value);
            if (isEmailMatched) {
                $inputEmail.classList.remove('invalid');
                $errorEmailMessage.classList.remove('active');
                $submitButton.disabled = false;
            }
            else {
                $inputEmail.classList.add('invalid');
                $errorEmailMessage.classList.add('active');
            }
        }
    }
    function createDigitCodeInput() {
        var _a;
        var $digitCodeLabel = document.createElement('label');
        (_a = $digitCodeInput.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore($digitCodeLabel, $digitCodeInput);
        var $digitCodeView = document.createElement('div');
        $digitCodeView.classList.add('digit-code__view');
        for (var i = 0; i < 6; i++) {
            var $digitCodeViewItem = document.createElement('div');
            $digitCodeViewItem.classList.add('digit-code__view-item');
            $digitCodeView.appendChild($digitCodeViewItem);
        }
        $digitCodeLabel.appendChild($digitCodeView);
        $digitCodeLabel.appendChild($digitCodeInput);
        $digitCodeInput.addEventListener('input', function () {
            updateDigitCode();
        });
        $digitCodeInput.addEventListener('focus', function () {
            updateDigitCode();
        });
        $digitCodeInput.addEventListener('blur', function () {
            for (var i = 0; i < 6; i++) {
                $digitCodeView.children[i].classList.remove('digit-code__view-item--active');
            }
        });
        function updateDigitCode() {
            $digitCodeInput.value = $digitCodeInput.value.replace(/\D/g, '');
            for (var i = 0; i < 6; i++) {
                $digitCodeView.children[i].innerHTML = $digitCodeInput.value[i] ? $digitCodeInput.value[i] : '';
                if (i === $digitCodeInput.value.length) {
                    $digitCodeView.children[i].classList.add('digit-code__view-item--active');
                }
                else {
                    $digitCodeView.children[i].classList.remove('digit-code__view-item--active');
                }
                $digitCodeButton.disabled = $digitCodeInput.value.length < 6;
            }
        }
    }
    function initCountrySelectFilter() {
        var _a;
        if (!$countrySearchList) {
            return;
        }
        if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
            return;
        }
        var normalize = function (value) { return value.trim().toLowerCase(); };
        var optionList = Array.from($countrySelect.options)
            .filter(function (option) { return option.value !== ''; })
            .map(function (option) { return ({
            value: option.value,
            label: (option.textContent || '').trim()
        }); });
        var suppressFocusOut = false;
        var toggleLabel = (_a = $countrySearch.getAttribute('placeholder')) !== null && _a !== void 0 ? _a : '';
        function applyFilter(value) {
            var search = normalize(value);
            var matches = optionList.filter(function (option) {
                var text = normalize(option.label);
                return search === '' || text.includes(search);
            });
            $countrySearchList.innerHTML = '';
            matches.forEach(function (option) {
                var button = document.createElement('button');
                button.type = 'button';
                button.className = 'country-search__option';
                button.textContent = option.label;
                button.dataset.value = option.value;
                button.setAttribute('role', 'option');
                $countrySearchList.appendChild(button);
            });
            $countrySearchList.style.display = matches.length > 0 ? 'block' : 'none';
        }
        function updateToggleState() {
            if (!$countrySearchToggle) {
                return;
            }
            var hasValue = normalize($countrySearch.value) !== '';
            $countrySearchToggle.classList.toggle('country-search__toggle--clear', hasValue);
            $countrySearchToggle.classList.toggle('country-search__toggle--open', !hasValue);
            if (toggleLabel) {
                $countrySearchToggle.setAttribute('aria-label', toggleLabel);
            }
        }
        function syncSearchFromSelect() {
            var selectedOption = $countrySelect.options[$countrySelect.selectedIndex];
            var selectedText = selectedOption && selectedOption.value !== '' ? (selectedOption.textContent || '').trim() : '';
            $countrySearch.value = selectedText;
            updateToggleState();
        }
        function hideList() {
            $countrySearchList.style.display = 'none';
        }
        function clearSelection() {
            $countrySelect.value = '';
            $countrySearch.value = '';
            applyFilter('');
            hideList();
            updateToggleState();
        }
        function handleOptionClick(target) {
            if (!target) {
                return;
            }
            var optionValue = target.getAttribute('data-value');
            if (!optionValue) {
                return;
            }
            $countrySelect.value = optionValue;
            var selectedOption = optionList.find(function (option) { return option.value === optionValue; });
            if (selectedOption) {
                $countrySearch.value = selectedOption.label;
            }
            else {
                syncSearchFromSelect();
            }
            updateToggleState();
            hideList();
        }
        $countrySearch.addEventListener('input', function () {
            applyFilter($countrySearch.value);
            updateToggleState();
        });
        $countrySearch.addEventListener('focus', function () {
            applyFilter($countrySearch.value);
        });
        $countrySearch.addEventListener('search', function () {
            if ($countrySearch.value === '') {
                clearSelection();
            }
            updateToggleState();
        });
        $countrySearch.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                clearSelection();
            }
        });
        $countrySearchList.addEventListener('click', function (event) {
            var target = event.target;
            var button = target instanceof Element ? target.closest('.country-search__option') : null;
            handleOptionClick(button);
            suppressFocusOut = false;
        });
        $countrySearchList.addEventListener('mousedown', function () {
            suppressFocusOut = true;
        });
        if ($countrySearchToggle) {
            $countrySearchToggle.addEventListener('mousedown', function () {
                suppressFocusOut = true;
            });
            $countrySearchToggle.addEventListener('click', function (event) {
                event.preventDefault();
                var hasValue = normalize($countrySearch.value) !== '';
                if (hasValue) {
                    clearSelection();
                }
                else {
                    applyFilter($countrySearch.value);
                    $countrySearch.focus();
                }
                updateToggleState();
                suppressFocusOut = false;
            });
        }
        document.addEventListener('click', function (event) {
            var rawTarget = event.target;
            var targetElement = rawTarget instanceof Element ? rawTarget : null;
            var target = targetElement !== null && targetElement !== void 0 ? targetElement : (rawTarget instanceof Node ? rawTarget.parentElement : null);
            if (!target) {
                return;
            }
            if (target === $countrySearch || target.closest('#countrySearchList') || target.closest('#countrySearchToggle')) {
                return;
            }
            syncSearchFromSelect();
            hideList();
        });
        $countrySearch.addEventListener('focusout', function (event) {
            if (suppressFocusOut) {
                return;
            }
            var nextTarget = event.relatedTarget;
            if (nextTarget && (nextTarget === $countrySelect || nextTarget.closest('#countryId') || nextTarget.closest('#countrySearchToggle'))) {
                return;
            }
            syncSearchFromSelect();
            hideList();
        });
        $countrySelect.addEventListener('change', function () {
            syncSearchFromSelect();
            hideList();
        });
        syncSearchFromSelect();
        updateToggleState();
        hideList();
    }
    function setCookie(name, value, options) {
        if (options === void 0) { options = {}; }
        options = __assign({ path: '/' }, options);
        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }
        var updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
        for (var optionKey in options) {
            updatedCookie += "; " + optionKey;
            var optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }
        document.cookie = updatedCookie;
    }
})();
function startResendTimer(untilResend) {
    var $resendButton = document.querySelector('#resendButton');
    if ($resendButton !== null) {
        if (untilResend <= 0) {
            $resendButton.disabled = false;
            return;
        }
        var $timer_1 = document.createElement('div');
        $resendButton.insertAdjacentElement('afterbegin', $timer_1);
        var interval_1 = window.setInterval(updateText, 1000);
        function updateText() {
            untilResend -= 1;
            var minutes = Math.floor(untilResend / 60);
            var seconds = untilResend % 60;
            $timer_1.innerText = (minutes < 10 ? "0".concat(minutes) : minutes) + ':' + (seconds < 10 ? "0".concat(seconds) : seconds);
            if (untilResend <= 0) {
                $timer_1.remove();
                $resendButton.disabled = false;
                window.clearInterval(interval_1);
            }
        }
    }
}
